import type { IntlShape } from 'react-intl';
import type { ConfirmOptions } from '../../../components/confirmContext';
import { unavailableMediaCount, type ExportMedia } from './exportMedia';

/**
 * Before rendering: when pictures would be left out of the PDF, ask whether to
 * export anyway. Offline, only what this device has already loaded can print —
 * and the sheet alone does not tell a missing picture from one never taken.
 * True when nothing is missing or the user goes ahead.
 *
 * Offline says so and why. Online a picture can still be missing — the device
 * that took it has not uploaded it yet — so the plain wording stays there.
 */
export function confirmUnavailableMedia(
    confirm: (options: ConfirmOptions) => Promise<boolean>,
    intl: IntlShape,
    media: Iterable<ExportMedia>
): Promise<boolean> {
    const count = unavailableMediaCount(media);
    if (count === 0) {
        return Promise.resolve(true);
    }
    return confirm({
        title: intl.formatMessage({ id: 'export.unavailableMedia.title' }),
        message: intl.formatMessage(
            {
                id:
                    navigator.onLine === false
                        ? 'export.unavailableMedia.messageOffline'
                        : 'export.unavailableMedia.message'
            },
            { count }
        ),
        confirmLabel: intl.formatMessage({
            id: 'export.unavailableMedia.confirm'
        })
    });
}
